import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import PersonalizedTextView from 'automation-ui-action-features/personalized-text/PersonalizedTextView';
import InAppNotificationRecipients from 'automation-ui-action-features/actions/in-app-notification/InAppNotificationRecipients';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InAppNotificationActionSummary({
  actionMetadata,
  flowObjectTypeId
}) {
  const {
    subject,
    body
  } = actionMetadata;
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.in-app-notification.summary",
    options: {
      subject: subject ? /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(PersonalizedTextView, {
          propertyTypeId: flowObjectTypeId
          // Hybrid classic flows only have one message field, which is interpreted as "body"
          ,
          text: subject || body || ''
        })
      }) : /*#__PURE__*/_jsx(MissingLabel, {
        type: "title"
      }),
      recipients: /*#__PURE__*/_jsx(InAppNotificationRecipients, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    }
  });
}